<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-position-error`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M38 16.976C38 8.706 31.284 2 23 2 14.716 2 8 8.705 8 16.976 8 22.49 13 29.498 23 38c10-8.502 15-15.51 15-21.024zM11.766 37a1 1 0 00-1-1H8.81a1 1 0 00-.978.793L6.305 44h.061l-.15.82A1 1 0 007.2 46h33.595a1 1 0 00.983-1.185L41.623 44h.071l-1.527-7.207-.03-.113a1 1 0 00-.948-.68h-1.956l-.117.007a1 1 0 00-.883.993l.006.104a1 1 0 00.016.103L37.27 42H10.728l1.016-4.793a.996.996 0 00.022-.207zM23 6c-6.077 0-11 4.916-11 10.976 0 3.59 3.585 8.97 11 15.703 7.415-6.732 11-12.113 11-15.703C34 10.916 29.076 6 23 6zm0 8.171l-2.828-2.828a1 1 0 00-1.415 0l-1.414 1.414a1 1 0 000 1.415L20.171 17l-2.828 2.828a1 1 0 000 1.415l1.414 1.414.095.083a1 1 0 001.32-.083l2.827-2.829 2.83 2.829a1 1 0 001.414 0l1.414-1.414a1 1 0 000-1.415L25.828 17l2.829-2.828a1 1 0 000-1.415l-1.414-1.414-.095-.083a1 1 0 00-1.32.083L23 14.171z"/></svg>
</template>
<script>

export default {
  name: 'IconPositionError',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
